import React from "react";
import { useI18n } from "@/i18n/I18nContext";

const LegalPage = ({ i18nKey, testId }) => {
  const { t, dict } = useI18n();
  const page = dict[i18nKey];
  return (
    <div className="bg-white" data-testid={testId}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
        <div className="text-xs font-mono uppercase tracking-widest text-[#C85A32] mb-3">
          Voryzix S.A.
        </div>
        <h1 className="font-serif font-bold text-3xl sm:text-4xl lg:text-5xl text-[#0B192C]">
          {t(`${i18nKey}.title`)}
        </h1>
        <p className="mt-3 text-xs font-mono uppercase tracking-widest text-[#475569]">
          {t(`${i18nKey}.updated`)}
        </p>
        <p className="mt-8 text-base text-[#1E293B] leading-relaxed">
          {t(`${i18nKey}.intro`)}
        </p>
        <div className="mt-10 space-y-8">
          {page.sections.map((s, i) => (
            <section key={i} data-testid={`${testId}-section-${i}`}>
              <h2 className="font-serif font-bold text-xl sm:text-2xl text-[#0B192C]">
                {s.title}
              </h2>
              <p className="mt-3 text-sm sm:text-base text-[#1E293B] leading-relaxed">
                {s.body}
              </p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export const PrivacyPolicy = () => (
  <LegalPage i18nKey="privacy" testId="privacy-page" />
);
export const CookiePolicy = () => (
  <LegalPage i18nKey="cookies_page" testId="cookie-policy-page" />
);
export const Terms = () => <LegalPage i18nKey="terms" testId="terms-page" />;
